package gr.tech.GRAttestation.infrastructure.api

import gr.tech.GRAttestation.models.activity.ActivityDTO
import gr.tech.GRAttestation.models.api.ApiError
import gr.tech.GRAttestation.models.api.ApiResponse
import gr.tech.GRAttestation.models.api.PaginatedResult
import gr.tech.GRAttestation.models.tables.BasicTableFilters
import gr.tech.GRAttestation.util.ROUTES

// CREATE
suspend fun adminRecordGenReceiptActivity(
    formId: Int,
    storeId: Int,
    onResponse: (ApiResponse<String>) -> Unit,
    onError: (ApiResponse<String>) -> Unit,
) {
    val url = "${ROUTES.BACKEND.ACTIVITY.RECEIPTS}?storeId=$storeId&formId=$formId"

    try {
        val result: ApiResponse<String> = safeApiCallStringBody(
            url = url,
            method = "POST"
        )
        onResponse(result)
    } catch (e: Exception) {
        onError(
            ApiResponse<String>(
                success = false,
                error = ApiError(
                    code = "db_error",
                    message = "Please Try Later!"
                )
            )
        )
        return
    }
}

// READ
suspend fun adminFetchAllActivity(
    pageNumber: Int,
    pageSize: Int,
    basicFilters: BasicTableFilters,
    onResponse: (ApiResponse<PaginatedResult<ActivityDTO>>) -> Unit,
    onError: (String) -> Unit,
) {
    val urlWithParameters = ROUTES.BACKEND.ACTIVITY.ACTIVITIES +
            "?page=$pageNumber&pageSize=$pageSize" +
            "&dateColumn=${basicFilters.dateColumn}" +
            "&asc=${basicFilters.isAscending}" +
            "&before=${basicFilters.isBefore}" +
            "&date=${basicFilters.dateString}"

    try {
        val result: ApiResponse<PaginatedResult<ActivityDTO>> = safeApiCallStringBody(
            url = urlWithParameters,
            method = "GET",
        )

        onResponse(result)
    } catch (e: Exception) {
        onError("failed to adminFetchAllProjects(): $e")
        return
    }
}

suspend fun adminFetchFormsActivitySummary(
    onResponse: (ApiResponse<List<ActivityDTO>>) -> Unit,
    onError: (String) -> Unit,
) {
    try {
        val result: ApiResponse<List<ActivityDTO>> = safeApiCallStringBody(
            url = ROUTES.BACKEND.ACTIVITY.FORMS_SUMMARY,
            method = "GET",
        )
        onResponse(result)
    } catch (e: Exception) {
        onError("failed to adminFetchFormsActivitySummary(): $e")
        return
    }
}

suspend fun adminFetchStoreActivitySummary(
    onResponse: (ApiResponse<List<ActivityDTO>>) -> Unit,
    onError: (String) -> Unit,
) {
    try {
        val result: ApiResponse<List<ActivityDTO>> = safeApiCallStringBody(
            url = ROUTES.BACKEND.ACTIVITY.STORE_SUMMARY,
            method = "GET",
        )
        onResponse(result)
    } catch (e: Exception) {
        onError("failed to adminFetchStoreActivitySummary(): $e")
        return
    }
}

suspend fun adminFetchAdminActivitySummary(
    onResponse: (ApiResponse<List<ActivityDTO>>) -> Unit,
    onError: (String) -> Unit,
) {
    try {
        val result: ApiResponse<List<ActivityDTO>> = safeApiCallStringBody(
            url = ROUTES.BACKEND.ACTIVITY.ADMIN_SUMMARY,
            method = "GET",
        )
        onResponse(result)
    } catch (e: Exception) {
        onError("failed to adminFetchAdminActivitySummary(): $e")
        return
    }
}
